import React from "react";
import { css } from "@emotion/react";
import { SwarovskiModalWrapper } from "../../components/_shared-components/ui-elements/SwarovskiModalWrapper";
import { fontColor, FONTS, fontSize } from "../../styles/fonts";
import { CSS_MQ } from "../../styles/breakpoints";
import { SwarovskiButton } from "../../components/_shared-components/ui-elements/SwarovskiButton";
import { usePdpTranslations } from "./PdpTranslationsContext";
import { T } from "../../components/T";
export const PDPModal: React.FC<{
  isModalOpen: boolean;
  hideModalCallback: () => void;
}> = ({ hideModalCallback, isModalOpen }) => {
  const t = usePdpTranslations();

  return (
    <SwarovskiModalWrapper modalIsOpen={isModalOpen} hideModalCallback={hideModalCallback}>
      <span
        css={[
          FONTS.SwarovskiFutura500,
          fontColor.black,
          fontSize.x25,
          css`
            margin-bottom: 30px;
            ${CSS_MQ.lowResNotebook} {
              margin-bottom: 20px;
            }

            text-align: center;
            text-transform: uppercase;
          `,
        ]}
      >
        <T>{t("addToCart.error.headline")}</T>
      </span>

      <p css={[FONTS.SwarovskiFutura300, fontSize.x2]}>
        <T>{t("addToCart.error.paragraph")}</T>
      </p>

      <SwarovskiButton variant={"green"} as={"button"} onClick={hideModalCallback}>
        <T>{t("addToCart.error.okButtonLabel")}</T>
      </SwarovskiButton>
    </SwarovskiModalWrapper>
  );
};
